import axios from '../shared/configuredAxios';

export default {
  signIn: (params) => (
    axios.post('/users/sign_in', params)
  ),
  sessionStatus: (params) => (
    axios.get('/sessions/status', { params })
  ),
  webauthnOptions: () => (
    axios.get('/sessions/webauthn_options')
  )
};
